<template>
    <div class="container">
        <div class="teacher_list">
            <ul class="level_tab dflex">
                <li class="tab_item" :class="{'active': !iscur}" @click="changeTabFn('','全部')"><span>全部</span></li>
                <li class="tab_item" :class="{'active': iscur == '1'}" @click="changeTabFn('1','小学')"><span>小学</span></li>
                <li class="tab_item" :class="{'active': iscur == '2'}" @click="changeTabFn('2','初中')"><span>初中</span></li>
                <li class="tab_item" :class="{'active': iscur == '3'}" @click="changeTabFn('3','高中')"><span>高中</span></li>
            </ul>
            <ul class="teacher_box dflex tac" v-if="detail&&detail.length">
                <li class="teach_item" v-for="item in detail" :key="item.id">
                    <nuxt-link :to="'/'+$route.params.nav+'/'+$route.params.channel+'/'+$route.params.subid+'/person/'+item.id" class="db" target="_blank">
                        <dl class="teach_item_content psr">
                            <dt class="tpicture"><img :src="$store.state.imgurl+item.imagePath" alt=""></dt>
                            <dd class="teachername">
                                <span class="tname" v-html="item.title"></span>
                            </dd>
                            <dd class="tdescrible oh">{{item.subTitle}}</dd>
                            <dd class="tags">{{item.section == '1'? '小学': item.section == '2'? '初中': '高中'}}{{item.subject}}</dd>
                        </dl>
                    </nuxt-link>
                </li>
            </ul>
            <template v-else>
                <nothing></nothing>
            </template>
            <p class="teach-total tac">{{sortname}}共{{detail.length}}特聘专家名师</p>
        </div>
    </div>
</template>
<script>
import { getTeacher} from '~/until/http.js'
import nothing from '~/components/nothing.vue'
export default {
    data (){
        return {
            iscur: "",
            sortname: '全部'
        }
    },
    async asyncData({isDev, route, store, env, params, query, req, res, redirect, error}) {
        let cont = await getTeacher(params.subid)
        return {
            detail: cont.content
        }
    },
    components: {
        nothing
    },
    mounted(){
        this.$store.commit('setrecorde', this.detail)
    },
    methods: {
        changeTabFn (section, name){
            getTeacher(this.$route.params.subid, section).then(res => {
                console.log(res)
                this.detail = res.content
                this.$store.commit('setrecorde', this.detail)
                this.iscur = section
                this.sortname = name
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.teach-total{
    color: #C2C2C2;
    padding: 20px;
}
.teacher_list{
    padding: 0 40px;
}
.teacher_box{
    flex-wrap: wrap;
    margin-left: -20px;
    margin-right: -20px;
}
.teachername{
    padding-top: 10px;
    padding-bottom: 3px;
}
.tdescrible{
    color: #333;
    line-height: 22px;
    display: -webkit-box;
    /*! autoprefixer: ignore next */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-height: 44px;
}
.tname{
    font-size: 18px;
    color: #333;
    font-weight: bold;
}
.tpicture{
    img{
        width: 83px;
        height: 106px;
    }
}
.teach_item_content{
    padding: 20px 35px;
    border: 1px solid #E9E9E9;
    .tags{
        position: absolute;
        line-height: 24px;
        background-color: #FFF3E5;
        padding: 0 10px;
        border-radius: 12px;
        font-size: 12px;
        color: #F7941D;
        top: 20px;
        right: 10px;
    }
}
.teach_item{
    width: 33.3333333%;
    padding: 0 20px ;
    box-sizing: border-box;
    margin-top: 20px;
    a{
        transition: all 0.3s;
        &:hover{
            box-shadow:0px 7px 13px 0px rgba(4,0,0,0.11);
        }
    }
}
.level_tab{
    padding-top: 10px;
}
.tab_item{
    cursor: pointer;
    transition: all 0.2s;
    margin-left: 30px;
    line-height: 28px;
    padding: 0 25px;
    color: #333;
    border: 1px solid #777;
    border-radius: 16px;
    &:hover,&.active{
        color: #fff;
        background: #F7941D;
        border-color: #F7941D;
    }
}
</style>
